export enum PaymentTypes {
    Unknown,
    Cash,
    Check,
    Card,
    ACH,
    Zelle,
    Venmo,
    ApplePay,
    Bitcoin
  }
  export enum PaymentStatusTypes {
    Unknown,
    Submitted,
    Pending,
    Completed,
    Failed,
    Canceled,
    DisputeNeedsResponse,
    DisputeAwaitingMerchantResponse,
    DisputeUnderReview,
    //DisputeResolved,
    DisputeWon,
    DisputeLost,
    RefundPending,
    RefundCompleted,
    RefundFailed,
    Authorized,
    PartiallyRefunded,
    FullyRefunded,
    Disputed
}


  export enum countryType{
    US='US',
    CA='CA'
  }
  export enum currencyType{
    USD='USD',
    CAD='CAD'
  }

  export enum PaymentFee {
    Company = 1,
    Customer
  }
  export enum PaymentType {
    CreditCard = 1,
    ACH
  }